import { Component, input } from '@angular/core';
import { Retailer } from '@root/app.interfaces';
import { BREAKPOINTS } from '@root/app.config';
import { DirectivesModule } from '@core/directives/directives.module';

@Component({
	selector: 'app-retailer-card-compact',
	standalone: true,
	imports: [DirectivesModule],
	templateUrl: './retailer-card-compact.component.html',
	styleUrls: ['./retailer-card-compact.component.scss', './retailer-card-compact.responsive.scss'],
})
export class RetailerCardCompactComponent {
	protected readonly breakpoints = BREAKPOINTS;
	retailer = input.required<Partial<Retailer>>();
}
